import { createSvgIcon } from "@mui/material/utils";
import React from "react";

const IconCheckbox = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H16C17.933 0.5 19.5 2.067 19.5 4V16C19.5 17.933 17.933 19.5 16 19.5H4C2.067 19.5 0.5 17.933 0.5 16V4Z"
      stroke="currentColor"
    />
  </svg>,
  "IconCheckbox",
);

export default IconCheckbox;
